var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"system-crashed"},[_vm._v("系统崩溃啦")])
}
var staticRenderFns = []

export { render, staticRenderFns }